// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.admanagement.listingoperations.RentalManagerUserClaimableListingsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings,
  RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties,
  RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Path,
  RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo,
  RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Path,
  RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings,
  RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage,
  RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim,
  RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ClaimCustomerListingsRequestDto,
  ClaimCustomerListingsResponseDto,
  CompanyPropertyClaimingDto,
  CustomerClaimingEmailMessageInfoDto,
  CustomerHasNewPropertiesToClaimResponseDto,
  ReleaseCustomerListingsRequestDto,
  ReleaseCustomerListingsResponseDto,
  SalesProUserInfoDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetClaimablePropertiesParams {
  pageSize?: number;
  startUnitId?: number;
  unitId?: number;
}

export interface RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Args {
  postData: ClaimCustomerListingsRequestDto;
}

export type RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Options = UseMutationOptions<
  ClaimCustomerListingsResponseDto,
  unknown,
  RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Args
>;

/**
 * Claim customer Listing
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Args) =>
      RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings(args.postData, httpClient),
  });
};

export type RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Options = UseQueryOptions<
  CompanyPropertyClaimingDto,
  unknown,
  CompanyPropertyClaimingDto,
  readonly [string, GetClaimablePropertiesParams]
>;

const RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_GetKey = (
  getParams: GetClaimablePropertiesParams,
) => [RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Path, getParams] as const;

export const RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_queryOptions = (
  getParams: GetClaimablePropertiesParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_GetKey(getParams),
    queryFn: () => RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Return CompanyId claimable properties
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties = (
  getParams: GetClaimablePropertiesParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties.getKey =
  RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_GetKey;

export type RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Options = UseQueryOptions<
  Array<SalesProUserInfoDto>,
  unknown,
  Array<SalesProUserInfoDto>,
  readonly [string]
>;

const RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_GetKey = () =>
  [RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Path] as const;

export const RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_GetKey(),
    queryFn: () => RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Return Logged User Sales Pro's Name and Email
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo.getKey =
  RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_GetKey;

export interface RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Args {
  postData: ReleaseCustomerListingsRequestDto;
}

export type RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Options = UseMutationOptions<
  ReleaseCustomerListingsResponseDto,
  unknown,
  RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Args
>;

/**
 * Release customer Listing
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Args) =>
      RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings(args.postData, httpClient),
  });
};

export interface RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Args {
  postData: CustomerClaimingEmailMessageInfoDto;
}

export type RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Args
>;

/**
 * Sent customer message to sales pro's Email
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Args) =>
      RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage(args.postData, httpClient),
  });
};

export type RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Options = UseQueryOptions<
  CustomerHasNewPropertiesToClaimResponseDto,
  unknown,
  CustomerHasNewPropertiesToClaimResponseDto,
  readonly [string]
>;

const RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_GetKey = () =>
  [RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Path] as const;

export const RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_GetKey(),
    queryFn: () => RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim(httpClient),
  }) as const satisfies QueryOptions;

/**
 * check if user has new properties to claim
 */
export const useRentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim.getKey =
  RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_GetKey;
